import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'cc-campaign-content-modal',
  templateUrl: './campaign-content-modal.component.html',
  styleUrls: ['./campaign-content-modal.component.scss']
})
export class CampaignContentModalComponent {
  @Input() isActive = false;
  @Output() isActiveChange = new EventEmitter();

  hideModal(): void {
    this.isActiveChange.emit(false);
  }
}
